module.exports = __webpack_public_path__ + "img/graph-types.45e14c7d.jpg";